import { MoneyLabel } from "../../../general/MoneyLabel.tsx";
import { Tag } from "../../../general/Tag.tsx";
import { DEFAULT_CURRENCY } from "../../../../types/constants.ts";
import { TaxPayment } from "../types";
import { formatPaidOn, paidAmount } from "../utils";

interface Props {
    payment: TaxPayment;
}

export function TaxPaymentRow({ payment }: Props) {
    return (
        <tr className="hover:bg-gray-50">
            <td className="py-2 pl-16 pr-4 text-[13px] text-gray-500">
                <span className="inline-flex items-center gap-2">
                    {payment.period_type || '—'}
                    {payment.is_additional_assessment && <Tag variant="warning" size="xs">naheffing</Tag>}
                </span>
            </td>
            <td className="px-4 py-2 text-[13px] text-gray-400 tabular-nums">
                {payment.assessment_code || '—'}
            </td>
            <td className="px-4 py-2 text-right text-[13px] text-gray-500 tabular-nums whitespace-nowrap">
                {formatPaidOn(payment.paid_on)}
            </td>
            <td className="px-4 py-2 text-right text-[13px] text-gray-500 tabular-nums whitespace-nowrap">
                <MoneyLabel value={paidAmount(payment)} showCurrency={true} currency={DEFAULT_CURRENCY}/>
            </td>
        </tr>
    );
}
